var _style, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemagWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156.2 37.9",
    style: {
      enableBackground: "new 0 0 156.2 37.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Gr\xFCn_x0020_bogenf\xF6rmig{fill:url(#SVGID_1_);stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:1;}\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -349.4092,
    y1: 361.7109,
    x2: -348.7021,
    y2: 361.0038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20AC4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    style: {
      stopColor: "#19361A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.4,0.5h7.4c1.3,0,2.6,0.1,3.9,0.4c1.3,0.3,2.5,0.9,3.5,1.7c1.1,0.8,1.9,1.9,2.6,3.3c0.6,1.4,0.9,3.3,0.9,5.5 c0,1.5-0.2,3.1-0.6,4.7c-0.4,1.7-1.2,3.3-2.3,4.7c-1.1,1.5-2.6,2.7-4.6,3.7c-2,1-4.6,1.5-7.7,1.5H0L5.4,0.5z M6,21.9h2.3 c7-0.1,10.4-3.9,10.4-11.3c0-2-0.7-3.6-2-4.6c-1.3-1-3.1-1.5-5.4-1.5H9.5L6,21.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.8,0.5h14.4l-0.7,4h-9.6l-1.3,6.3h8.6l-0.8,4h-8.6l-1.4,7.2h9.7l-0.9,4H24.6L29.8,0.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.2,0.5h8.1L59,18.8h0.1l9.7-18.4h8.2l-5.2,25.5h-5.2l4.6-21.1h-0.1L59.9,25.9h-4.7l-2-21.1h-0.1l-4.5,21.1 H44L49.2,0.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.2,0.5h5.7l4.6,25.5h-5.1l-0.9-5.8H83.7l-3.3,5.8h-5.6L90.2,0.5z M85.9,16.1h7.9L92.2,5H92L85.9,16.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.2,5.8c-2-1.2-4.2-1.8-6.8-1.8c-3,0-5.4,1.1-7.1,3.1c-1.7,2-2.6,4.6-2.6,7.8c0,2.1,0.6,3.9,1.9,5.3 c1.2,1.4,2.9,2.2,5,2.2c1.1,0,1.9-0.1,2.4-0.3l1.4-6.8h-5.2l0.8-4h10l-2.8,13.9c-1.7,0.7-3.9,1.1-6.6,1.1c-3.6,0-6.6-0.9-8.7-2.7 c-2.2-1.8-3.3-4.7-3.3-8.6c0-4.7,1.4-8.4,4.1-11c2.6-2.7,6.2-4,10.7-4c2.8,0,5.5,0.5,8.2,1.4L124.2,5.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "112.3,32.3 111.4,37.9 115.6,37.9 116.6,32.3 112.3,32.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "104.7,32.3 103.6,37.9 108.2,37.9 109.3,32.3 104.7,32.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "136.7,32.3 135.8,37.9 139.2,37.9 140,32.3 136.7,32.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "120.2,32.3 119.3,37.9 123.1,37.9 124,32.3 120.2,32.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "128.3,32.3 127.3,37.9 131.1,37.9 132.1,32.3 128.3,32.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.1,32.3 63.9,37.9 100.3,37.9 101.4,32.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "145.1,32.3 144.2,37.9 147.1,37.9 148.1,32.3 145.1,32.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "153.7,32.3 152.7,37.9 155.4,37.9 156.2,32.3 153.7,32.3  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemagWhite);
export default __webpack_public_path__ + "static/media/demag-white.cb017b8a1ba94a6466ed6923ed2432e4.svg";
export { ForwardRef as ReactComponent };